module.exports = __webpack_public_path__ + "img/iconDevice-Orange.0bc82df1.svg";